
angular.module('trainerWebApp.services').factory('manageUsersGrouping', ['sorting', function (sorting) {

  var maxItemsInGroup = 50;

  function setupCustomFieldValues(users, field) {
    var fieldKey = 'customField' + field.id;
    var allValuesSorted = _.chain(users)
      .map(function (u) {
        return u[fieldKey];
      })
      .compact()
      .sortBy(function (f) {
        return f;
      }).value();

    var grouping = {};
    var itemsCreated = 0;
    var hasMore = false;

    function groupCustomFieldValues() {
      for (var i = 0; i < allValuesSorted.length; i++) {
        var value = allValuesSorted[i];
        var item = grouping[value];
        if (!item) {
          if (itemsCreated == maxItemsInGroup) {
            hasMore = true;
            return;
          }
          item = grouping[value] = 1;
          itemsCreated++;
        }
        else {
          grouping[value]++;
        }
      }
    }

    groupCustomFieldValues();

    field.values =
      _.chain(grouping)
        .pairs()
        .map(function (pair) {
          return {
            value:pair[0],
            count:pair[1] == users.length ? 'All' : pair[1]
          };
        })
        .value()
        .sort(sorting.byName('value'));

    field.hasMoreValues = hasMore;

    return field;
  }

  function groupUserGroups(users, userGroupsLookup) {
    return _.chain(users)
      .pluck('groupMemberships')
      .compact()
      .flatten()
      .countBy(function (gm) {
        return gm;
      })
      .pairs()
      .map(function (pair) {
        var userGroup = userGroupsLookup[pair[0]];
        return {
          id:userGroup.id,
          name:userGroup.name,
          count:pair[1] == users.length ? 'All' : pair[1]
        }
      })
      .value()
      .sort(sorting.byName('name'));
  }

  function groupUserCourses(users, courseLookup) {
    return groupUserCoursesOrSeries(users, 'courses', courseLookup);
  }

  function groupUserSeries(users, seriesLookup) {
    return groupUserCoursesOrSeries(users, 'series', seriesLookup);
  }

  function groupUserCoursesOrSeries(users, propertyName, lookup) {
    return _.chain(users)
      .pluck(propertyName)
      .map(function(courses) {
        var allCourses = [];
        if (courses) {
          if (courses.completed)
            allCourses = allCourses.concat(courses.completed);
          if (courses.required)
            allCourses = allCourses.concat(courses.required);
          if (courses.optional)
            allCourses = allCourses.concat(courses.optional);
        }

        return allCourses;
      })
      .flatten()
      .countBy(function (course) {
        return course.courseId;
      })
      .pairs()
      .map(function (pair) {
        var course = lookup[pair[0]];
        if (!course)
          return;
        return {
          id: course.id,
          name: course.name,
          count: pair[1] == users.length ? 'All' : pair[1]
        }
      })
      .value()
      .sort(sorting.byName('name'));
  }

  function sortByGroupName (a,b) {
    return a.groupName.toLowerCase()  < b.groupName.toLowerCase()  ? -1 : 1;
  }


  if (!singleton){
    var singleton = {
      setupCustomFieldValues:setupCustomFieldValues,
      groupUserGroups: groupUserGroups,
      groupUserCourses: groupUserCourses,
      groupUserSeries: groupUserSeries,
      sort: {
        byGroupName: sortByGroupName
      }
    };
  }

  return singleton;
}]);
